module.exports = __webpack_public_path__ + "img/suzuki-ignis.c9b63e3f.jpg";